<template>
  <div class="flex items-center search-type-selector">
    <label class="flex items-center cursor-pointer">
      <Checkbox :checked="selectedType === 'standard'" @update:checked="toggleSearchType" />
      <span class="ml-2 text-xs lg:text-sm text-theme-primary">
        {{ $t('Disable AI search') }}
      </span>
    </label>
    <div class="flex items-center ml-1">
      <tippy class="cursor-help">
        <Icon class="text-theme-primary" type="info" color="currentColor" outer-class="w-5 h-5" />
        <template #content>
          <p>
            {{
              $t(
                "AI-Powered search is enabled by default. It understands the meaning behind your query and finds relevant results even when they don't contain the exact words."
              )
            }}
          </p>
          <p class="mt-1">
            {{ $t('Check this box to disable AI and use standard keyword search instead.') }}
          </p>
        </template>
      </tippy>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { Tippy } from 'vue-tippy';
import Icon from '@/Icons/OptimizedIcons.vue';
import Checkbox from '@/Components/Checkbox.vue';

const props = defineProps({
  initialSearchType: {
    type: String,
    default: 'vector',
  },
});

const emit = defineEmits(['update:search-type']);

const selectedType = ref(props.initialSearchType || 'vector');

// React to external changes to the search type
watch(
  () => props.initialSearchType,
  (newType) => {
    if (newType && newType !== selectedType.value) {
      selectedType.value = newType;
    }
  }
);

// Get search type from URL parameters
const getSearchTypeFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('search_type');
};

// Handle checkbox state change
const toggleSearchType = (isStandardSearch) => {
  selectedType.value = isStandardSearch ? 'standard' : 'vector';
  emit('update:search-type', selectedType.value);
  // Only update state without page reload or search execution
};

defineExpose({ selectedType });

onMounted(() => {
  // Initialize value from props or URL parameter
  selectedType.value = getSearchTypeFromUrl() || 'vector';
});
</script>
